import { render, staticRenderFns } from "./FiltroAtendimento.vue?vue&type=template&id=3fe8b3eb"
import script from "./FiltroAtendimento.vue?vue&type=script&lang=js"
export * from "./FiltroAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports